import { Component, Input, OnInit } from '@angular/core';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import SlotService from '../../cart-process/slot.service';
import SlotModel from '../../models/slot.model';
import { ICartDetails } from '../../interfaces/cart-details.interface';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { IExtendedAdditionalBundleSet } from '../../interfaces/additional-bundles.interface';

@Component({
  selector: 'side-order-details',
  templateUrl: './side-order-details.component.html',
})
export class SideOrderDetailsComponent implements OnInit {
  @Input('offer-title') public offerTitle: string;

  public slots: SlotModel[];
  public additionalBundles: IExtendedAdditionalBundleSet[];

  constructor(
    private notificationProvider: NotificationProviderService,
    private slotService: SlotService,
    private commonInfo: CommonInfoService,
  ) {}

  ngOnInit(): void {
    this.notificationProvider.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails) {
        this.slots = this.slotService.getSlots();
        this.additionalBundles = this.slotService.getAdditionalBundles();
      }
    });
  }

  public get showDiscountBar() {
    return this.commonInfo.simCardDiscount && this.commonInfo.simCardDiscountApplied === true
      || this.commonInfo.isNextSim && this.slots.length + this.commonInfo.currentlyProcessed >= this.commonInfo.simCardDiscount?.requiredParticipants
      && this.commonInfo.currentlyProcessed <= this.commonInfo.simCardDiscount?.requiredParticipants - 1;
  }
}
